import React, { useState } from 'react'
import { Button, Dropdown, Label, Header, Table, Container, Icon } from 'semantic-ui-react'
import './UsageDashboardPage.css'
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import { useGetUsageQuery } from './usageDashboardApiSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';


const partnerOptions = [
    { key: 'Tesla', text: 'Tesla', value: 'Tesla' },
    { key: 'Apple', text: 'Apple', value: 'Apple' },
]

const versionOptions = [
    { key: 'V1', text: 'V1', value: 'V1' },
    { key: 'V2', text: 'V2', value: 'V2' },
]

const UsageDashboardPage = () => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [partners, setPartners] = useState([]);
    const [versions, setVersions] = useState([]);


    const location = useLocation();
    const navigate = useNavigate();

    const queryParams = new URLSearchParams(location.search);
    const start_date = queryParams.get("startDate");
    const end_date = queryParams.get("endDate");
    const partner = queryParams.get("partners");
    const version = queryParams.get("versions");

    // get query params from frontend url -> remove null ones to pass to backend
    let qp = { start_date, end_date, partner, version };
    qp = Object.entries(qp)
        .filter((e) => e[1])
        .reduce((accumulator, [k, v]) => {
            accumulator[k] = v;
            return accumulator;
        }, {});

    // GET chat sessions
    const { data, isLoading, isSuccess, isError, error } =
        useGetUsageQuery({ ...qp });


    const handleSearch = () => {
        let queryParams = [];

        if (startDate) {
            queryParams.push(`startDate=${encodeURIComponent(moment(startDate).format('yyyy-MM-DD'))}`);
        }

        if (endDate) {
            queryParams.push(`endDate=${encodeURIComponent(moment(endDate).format('yyyy-MM-DD'))}`);
        }

        if (partners.length > 0) {
            const partnersValues = partners.map(value => encodeURIComponent(value));
            queryParams.push(`partners=${partnersValues.join(',')}`);
        }

        if (versions.length > 0) {
            const versionsValues = versions.map(value => encodeURIComponent(value));
            queryParams.push(`versions=${versionsValues.join(',')}`);
        }


        const url = `/usage?${queryParams.join('&')}`;
        navigate(url)
        window.location.reload()
    }



    return (
        <div style={{ backgroundColor: '#f9fafb', minHeight: '100vh' }}>
            {/* Header Section */}
            <div style={{ 
                padding: '16px 0', 
                backgroundColor: 'rgba(255, 255, 255, 0.9)', 
                backdropFilter: 'blur(20px)',
                borderBottom: '1px solid rgba(0,0,0,0.05)', 
                marginBottom: '20px'
            }}>
                <Container>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{ 
                            width: '40px', 
                            flexShrink: 0, // stays a circle when the text beside it wraps
                            height: '40px', 
                            borderRadius: '50%', 
                            backgroundColor: '#F2F2F7', 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center' 
                        }}>
                            <Icon name="dashboard" style={{ margin: 0, color: '#007AFF', fontSize: '18px' }} />
                        </div>
                        <div>
                            <h2 style={{ fontSize: '17px', fontWeight: '600', margin: 0, color: '#1d1d1f' }}>Usage Dashboard</h2>
                            <p style={{ fontSize: '13px', color: '#86868b', margin: 0 }}>View usage statistics</p>
                        </div>
                    </div>
                </Container>
            </div>

            <div className='usage-dashboard-container' style={{ padding: '0 20px' }}>
                <div className='filters'>
                <Dropdown className='filter' placeholder='Partner' value={partners} fluid multiple selection options={partnerOptions} onChange={(event, data) => setPartners(data.value)} />
                <Dropdown className='filter' placeholder='Version' value={versions} fluid multiple selection options={versionOptions} onChange={(event, data) => setVersions(data.value)} />
                <div className='date filter'>
                    <DatePicker selected={startDate} placeholderText='Start Date' dateFormat="dd/MM/yyyy" onChange={(date) => setStartDate(date)} />
                </div>
                <div className='date filter'>
                    <DatePicker selected={endDate} placeholderText='End Date' dateFormat="dd/MM/yyyy" onChange={(date) => setEndDate(date)} />
                </div>
                <Button onClick={handleSearch}>Search</Button>
            </div>
            {data &&
                <div className='data-container'>
                    <Header size='large'>Total found sessions: {data.total_sessions}</Header>
                    <Header size='medium'>Total found completions: {data.total_completions}</Header>

                    <Table celled striped>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan='1'>Model</Table.HeaderCell>
                                <Table.HeaderCell colSpan='1'>Total Completions</Table.HeaderCell>
                                <Table.HeaderCell colSpan='1'>Prompt Tokens</Table.HeaderCell>
                                <Table.HeaderCell colSpan='1'>Completion Tokens</Table.HeaderCell>
                                <Table.HeaderCell colSpan='1'>Total Tokens</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {Object.keys(data.model_totals).map((model) => {
                                const modelData = data.model_totals[model];
                                return (
                                    <tr key={model}>
                                        <td>{model}</td>
                                        <td>{modelData.total_completions}</td>
                                        <td>{modelData.total_prompt_tokens}</td>
                                        <td>{modelData.total_completion_tokens}</td>
                                        <td>{modelData.total_total_tokens}</td>
                                    </tr>
                                );
                            })}
                        </Table.Body>
                    </Table>


                    <Table celled striped>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan='1'>Task Type</Table.HeaderCell>
                                <Table.HeaderCell colSpan='1'>Total Completions</Table.HeaderCell>
                                <Table.HeaderCell colSpan='1'>Prompt Tokens</Table.HeaderCell>
                                <Table.HeaderCell colSpan='1'>Completion Tokens</Table.HeaderCell>
                                <Table.HeaderCell colSpan='1'>Total Tokens</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {Object.keys(data.task_type_totals).map((task_type) => {
                                const taskTypeData = data.task_type_totals[task_type];
                                return (
                                    <tr key={task_type}>
                                        <td>{task_type}</td>
                                        <td>{taskTypeData.total_completions}</td>
                                        <td>{taskTypeData.total_prompt_tokens}</td>
                                        <td>{taskTypeData.total_completion_tokens}</td>
                                        <td>{taskTypeData.total_total_tokens}</td>
                                    </tr>
                                );
                            })}
                        </Table.Body>
                    </Table>

                </div>
            }
        </div>
        </div>
    )
}

export default UsageDashboardPage

